import React from "react";
// reactstrap components

import LargeWidget from "components/Widget/large-widget.jsx";
import SmallWidget from "components/Widget/small-widget.jsx";

import {
  Row,
  Col
} from "reactstrap";

import axios from 'axios';

class Dash extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      weatherIconID: "",
      message: "",
      temp: "",
      humidity:"",
      sunrise: "" ,
      sunset: "",
    };
  }

  round(num){
    return Math.round(num * 100) / 100;
  }

  timeFix(d){
    return ('0' + d).slice(-2);
  }

  dateParser = (UTCtime) => {
    const date = new Date(UTCtime);
      return date.getHours() + ":" + this.timeFix(date.getMinutes()) + ":" + this.timeFix(date.getSeconds());
  }

  getWeather(){
    // console.log("getWeather");
    axios.get(`http://api.openweathermap.org/data/2.5/weather?q=hamilton,ca&appid=5d039194d39382dc0c73ded9b0686ff3`)
    .then(res => {
      console.log(res);
        this.setState({
          weatherIconID: res.data.weather[0].icon,
          message: res.data.weather[0].description,
          temp: this.round(res.data.main.temp -273.15),
          humidity:this.round(res.data.main.humidity),
          sunrise: this.dateParser(res.data.sys.sunrise *1000),
          sunset: this.dateParser(res.data.sys.sunset *1000),
        });
      });
  }

  componentDidMount(){
    this.getWeather();
    this.interval = setInterval(() => this.getWeather(), 60000);
  }

  componentWillUnmount(){
    clearInterval(this.interval);
  }

  render() {
    return (
      <>
      <div className="content">
          <Row>
            <Col lg="3" sm="6">
              <SmallWidget currentMode={this.props.currentMode} weatherIconID={this.state.weatherIconID} title={"Conditions"} info={this.state.message} sun={""}/>
            </Col>
            <Col lg="3" sm="6">
              <SmallWidget currentMode={this.props.currentMode} weatherIconID={"thermometer"} title={"Temperature"} info={this.state.temp + " °C"} sun={""}/>
            </Col>
            <Col lg="3" sm="6">
              <SmallWidget currentMode={this.props.currentMode} weatherIconID={"humidity"} title={"Humidity"} info={this.state.humidity+"%"} sun=""/>
            </Col>
            <Col lg="3" sm="6">
              <SmallWidget currentMode={this.props.currentMode} weatherIconID={"sunset"} title={""} sun={"Sunrise: " + this.state.sunrise + "\n" + "Sunset: " + this.state.sunset}/>
            </Col>

          </Row>
          <Row>
            <Col lg="4">
              <LargeWidget id={"one"} store={this.props.store} varText={this.props.dash.one} saveVariable={this.props.saveVariable}/>
            </Col>
            <Col lg="4">
              <LargeWidget id={"two"} store={this.props.store} varText={this.props.dash.two} saveVariable={this.props.saveVariable}/>
            </Col>
            <Col lg="4">
              <LargeWidget id={"three"} store={this.props.store} varText={this.props.dash.three} saveVariable={this.props.saveVariable}/>
            </Col>
          </Row>
          <Row>
            <Col lg="4">
              <LargeWidget id={"four"} store={this.props.store} varText={this.props.dash.four} saveVariable={this.props.saveVariable}/>
            </Col>
            <Col lg="4">
              <LargeWidget id={"five"} store={this.props.store} varText={this.props.dash.five} saveVariable={this.props.saveVariable}/>
            </Col>
            <Col lg="4">
              <LargeWidget id={"six"} store={this.props.store} varText={this.props.dash.six} saveVariable={this.props.saveVariable}/>
            </Col>
          </Row>
      </div>
      </>
    );
  }
}

export default Dash;
